export class VerificationOutcome {
  statusReason: string;
  additionalDetails?: string;
  blockingReversalExempt?: boolean;
  nonBlockingReversal?: boolean;
  specialtyMismatchExempt?: boolean;
  ceReviewNote?: string;
}
